import { useState } from "react";

//Components
import { Fab, FormControl, Tooltip } from "@material-ui/core";
import { Link } from "react-router-dom";
import AddressHistoryModal from "./AddressHistoryModal";

//styling
import { useStyles } from "../Styles/styles";
import AddressPeopleModal from "./AddressPeopleModal";

const HistoryMapInfo = ({
  address,
  incidentId = null,
  handleIncidentOpening,
  handleTicketOpening,
  handlePersonOpening,
  incidentPeople,
  showPeople = false,
  ...props
}) => {
  const classes = useStyles();
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [peopleModalOpen, setPeopleModalOpen] = useState(false);

  return (
    <FormControl
      style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
    >
      <Tooltip title={"Address History"}>
        <span>
          <Fab
            disabled={!address?.id}
            data-cy="call-location-history-button"
            style={{ backgroundColor: "#611e24" }}
            className={classes.fabButton}
            onClick={() => setHistoryModalOpen(true)}
          >
            H
          </Fab>
        </span>
      </Tooltip>

      {address?.id ? (
        <Tooltip title={"Map"}>
          <Link
            style={{ textDecoration: "none" }}
            data-cy="tablecell-incident-number-link"
            target="_blank"
            rel="noreferrer"
            to={`/mp/map/address/${address?.id}/${incidentId}`}
          >
            <Fab
              style={{ backgroundColor: "#4679BD" }}
              data-cy="call-location-map-button"
              className={classes.fabButton}
            >
              M
            </Fab>
          </Link>
        </Tooltip>
      ) : (
        <Tooltip title={"Map"}>
          <span>
            <Fab
              disabled={!address?.id}
              style={{ backgroundColor: "#4679BD" }}
              data-cy="call-location-map-button"
              className={classes.fabButton}
            >
              M
            </Fab>
          </span>
        </Tooltip>
      )}
      {showPeople && (
        <Tooltip title={"People"}>
          <span>
            <Fab
              disabled={!address?.id}
              style={{ backgroundColor: "#90baf9" }}
              className={classes.fabButton}
              onClick={() => setPeopleModalOpen(true)}
            >
              P
            </Fab>
          </span>
        </Tooltip>
      )}
      <AddressHistoryModal
        modalOpen={historyModalOpen}
        setModalOpen={setHistoryModalOpen}
        address={address}
        {...props}
      />
      <AddressPeopleModal
        modalOpen={peopleModalOpen}
        setModalOpen={setPeopleModalOpen}
        address={address}
        incidentId={incidentId}
        handleIncidentOpening={handleIncidentOpening}
        handleTicketOpening={handleTicketOpening}
        handlePersonOpening={handlePersonOpening}
        incidentPeople={incidentPeople}
        {...props}
      />
    </FormControl>
  );
};

export default HistoryMapInfo;
